<template>
  <div class="intro col-span-12">
    <span class="w-full text-danger text-red text-center mt-4"></span>
  </div>
</template>
<script>
export default {
  name: 'FormErrorBox'
}
</script>